export const validateEmptyField = (field: string): boolean => {
    return !field || field.trim().length === 0;
}

export const validateNif = (nif: string): boolean => {
    // Check if the NIF has 9 digits and is numeric.
    if (!nif || nif.length !== 9 || !/^\d{9}$/.test(nif)) {
        return false;
    }

    // The first digit of a NIF cannot be 0.
    const firstDigit = Number.parseInt(nif[0], 10);
    if (firstDigit === 0) {
        return false;
    }

    // Calculate the check digit using the Modulus 11 algorithm.
    const checkDigit = Number.parseInt(nif[8], 10);
    let sum = 0;

    for (let i = 0; i < 8; i++) {
        sum += Number.parseInt(nif[i], 10) * (9 - i);
    }

    const remainder = sum % 11;
    const calculatedCheckDigit = remainder < 2 ? 0 : 11 - remainder;

    // Compare the calculated check digit with the one from the NIF.
    return checkDigit === calculatedCheckDigit;
};

export const validateCodigo = (codigo: string): boolean => {
    return /^[a-z0-9]{12}$/i.test(codigo);
};